import { useState } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "./index";

// Small bottom banner asking for analytics consent. Shown only when GA is configured and the
// visitor has not decided yet. Both buttons are equally prominent. Copy is English + Japanese.
const COPY = {
  en: {
    text: "We use Google Analytics to understand how the site is used and to improve it. No ads, no advertising ID.",
    accept: "Accept",
    decline: "Decline",
    policy: "Privacy Policy",
  },
  ja: {
    text: "サイトの利用状況を把握し改善するため、Google アナリティクスを使用します。広告には使用しません。",
    accept: "同意する",
    decline: "同意しない",
    policy: "プライバシーポリシー",
  },
};

export default function ConsentBanner() {
  const [decided, setDecided] = useState(() => analytics.getConsent() !== null);
  useLocation(); // re-evaluate on route change (the banner is hidden on staff pages)
  if (!analytics.isEnabled() || analytics.isStaffPage() || decided) return null;
  const lang = (navigator.language || "en").startsWith("ja") ? "ja" : "en";
  const t = COPY[lang];
  const choose = (granted) => {
    analytics.setConsent(granted);
    setDecided(true);
  };
  const btn = {
    padding: "8px 16px",
    borderRadius: 8,
    border: "1px solid #4b5aa2",
    background: "#fff",
    color: "#4b5aa2",
    cursor: "pointer",
    fontWeight: 600,
  };
  return (
    <div
      role="dialog"
      aria-label="Analytics consent"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        background: "#fff",
        borderTop: "1px solid #ddd",
        padding: "12px 16px",
        display: "flex",
        gap: 12,
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        fontSize: 14,
      }}
    >
      <span>
        {t.text}{" "}
        <a href="/privacy-policy" style={{ color: "#4b5aa2", textDecoration: "underline" }}>
          {t.policy}
        </a>
      </span>
      <button type="button" style={btn} onClick={() => choose(true)}>
        {t.accept}
      </button>
      <button type="button" style={btn} onClick={() => choose(false)}>
        {t.decline}
      </button>
    </div>
  );
}
